import Model, { attr, belongsTo } from '@ember-data/model';

export default class Author extends Model {
  @attr('string')
  fullName;

  @belongsTo('user', { async: true, inverse: 'author' })
  user;
}
